import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  opacity: ${({ active }) => (active ? "1" : "0")};
  visibility: ${({ active }) => (active ? "visible" : "hidden")};
  transition: all 0.5s ease;
`;
export const Progression = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.8rem;
  justify-content: space-between;
`;

export const Status = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 0.945rem;
  padding: 0.125rem 0.625rem;
  border-radius: 0.1875rem;
  font-family: Sora;

  background: ${({ status }) =>
    status === "Em dia"
      ? "#A0F69E"
      : status === "Atrasado"
      ? "#FFBAAB"
      : status === "Concluido"
      ? "#118052"
      : "#EFF1F5"};

  color: ${({ status }) =>
    status === "Em dia"
      ? "#1C7A1A"
      : status === "Atrasado"
      ? "#D93333"
      : status === "Concluido"
      ? "#EFF1F5"
      : "#7E858F"};
`;
export const ProgressionBar = styled.div`
  width: 9rem;
  background: #e1dfdf;
  height: 0.705625rem;
  border-radius: 0.29413825rem;
  margin-right: 0.765rem;

  position: relative;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    background: ${({ status }) =>
      status === "Em dia"
        ? "#49b446"
        : status === "Atrasado"
        ? "#D93333"
        : status === "Concluido"
        ? "#118052"
        : "#7E858F"};

    //background: #49b446;
    color: #fff;
    height: 100%;
    font-size: 0.51rem;
    line-height: 0;
    border-radius: 0.29413825rem;
  }
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.51rem;
    color: #000;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 1px;
    left: 0;
  }
`;

export const Description = styled.div`
  font-family: Sora;
  font-size: 0.70625rem;
  margin-left: 0.8rem;
  margin-top: 1.1rem;
  width: 90%;

  span {
    color: #212326;
    font-weight: 600;
  }

  p {
    margin-top: 1.1rem;
    color: #7e858f;
    text-overflow: ellipsis;
    overflow-x: hidden;
  }
`;

export const Prevision = styled.div`
  margin-top: 1.1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.8rem;
  border: 0.941243px solid #d4d6da;
  border-radius: 0.0764rem;
  width: 14.883125rem;
  font-size: 0.70625rem;
  height: 3.8825rem;
`;

export const Date = styled.div`
  margin-left: 00.889375rem;
  display: flex;
  span {
    font-weight: 600;
  }
`;

export const Remaing = styled.div`
  color: #49b446;
  font-family: Sora;
  font-size: 0.646875;
  margin-left: 0.5rem;

  &:before {
    content: "•";
    margin-right: 0.5rem;
  }
`;
export const Author = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2.1175rem;
  margin-left: 0.8rem;
`;

export const AuthorSubsection = styled.div`
  display: flex;
`;

export const Avatar = styled.img`
  max-width: 1.765rem;
  max-height: 1.765rem;
  background: lightblue;
  border-radius: 50%;
  margin-right: 0.5125rem;
  align-self: center;
`;

export const ContentUser = styled.div`
  font-size: 0.70625rem;
  display: flex;
  flex-direction: column;

  height: 1.8825rem;
  margin-top: 0.5125rem;
`;
export const Name = styled.span`
  line-height: 0.8897375rem;
`;
export const Email = styled.span`
  color: #9c9c9c;
  margin-top: 0.17625rem;
  line-height: 0.815325rem;
`;
export const TasksManager = styled.div`
  display: flex;
  flex-direction: column;

  flex-wrap: wrap;
  margin-left: 0.8rem;
  margin-top: 2rem;
  padding-bottom: 1rem;
`;

export const Total = styled.div`
  width: 6.34125rem;
  height: 5.294375rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1.1rem;
  font-weight: 600;
  color: #1f499f;

  strong {
    font-size: 1.1rem;
  }

  span {
    font-size: 0.64375rem;
  }

  background: linear-gradient(
    128.59deg,
    #b9e8f7 0%,
    rgba(85, 155, 220, 0.81) 96.36%
  );

  box-shadow: 0px 0.235310625rem 0.70593125rem rgba(6, 63, 116, 0.15);
  border-radius: 5.64746px;
`;

export const Pending = styled.div`
  width: 6.34125rem;
  height: 5.294375rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    128.59deg,
    #fffdd3 0%,
    #fffdd3 0.01%,
    rgba(255, 218, 174, 0.81) 96.36%
  );
  box-shadow: 0px 0.235310625rem 0.70593125rem rgba(6, 63, 116, 0.15);
  border-radius: 5.64746px;
  color: #807228;

  strong {
    font-size: 1.1rem;
  }

  span {
    font-size: 0.64375rem;
  }
`;

export const Late = styled.div`
  width: 6.34125rem;
  height: 5.294375rem;
  margin-left: 1.0825rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(128.59deg, #ffe2dc 0%, #f2bbb0 96.36%);

  box-shadow: 0px 0.235310625rem 0.70593125rem rgba(6, 63, 116, 0.15);
  border-radius: 5.64746px;
  color: #d93333;

  strong {
    font-size: 1.1rem;
  }

  span {
    font-size: 0.64375rem;
  }
`;

export const Done = styled.div`
  width: 6.34125rem;
  height: 5.294375rem;
  margin-left: 1.0825rem;
  margin-bottom: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(128.59deg, #affbad 0%, #8fcc85 96.36%);

  box-shadow: 0px 0.235310625rem 0.70593125rem rgba(6, 63, 116, 0.15);
  border-radius: 5.64746px;
  color: #118052;

  strong {
    font-size: 1.1rem;
  }

  span {
    font-size: 0.64375rem;
  }
`;
